<script src="../postcssrc.js"></script>
<template>
  <v-app>
    <div v-shortkey="['ctrl', 'd']" @shortkey="toggleDevMode()" style="display: none">GlobalHotKeyCatcher</div>
    <v-toolbar fixed app flat class="main-menu" tabs color="primary" dark height="50px" v-if="isLogged">
      <div class="main-menu-item">
        <router-link color="blue lighten-5" to="/dashboard">Dashboard</router-link>
      </div>
      <div class="main-menu-item">
        <router-link color="blue lighten-5" to="/sales">Sales</router-link>
      </div>
      <div class="main-menu-item">
        <router-link color="blue lighten-5" to="/reference">Reference</router-link>
      </div>
      <div class="main-menu-item">
        <router-link color="blue lighten-5" to="/performance">Performance</router-link>
      </div>
      <div class="main-menu-item">
        <router-link color="blue lighten-5" to="/analytics">Analytics</router-link>
      </div>

      <v-spacer></v-spacer>

      <v-btn color="primary" style="color: white!important;" flat @click="logout">
        Logout
      </v-btn>
    </v-toolbar>
    <template>
      <vue-snotify/>
      <div class="content-wrapper">
        <div>
          <router-view></router-view>
        </div>
      </div>
    </template>
    <v-footer color="primary" dark absolute v-if="isLogged">
      <v-spacer></v-spacer>
      <span class="mr-2">UNIM Digital Pathology v.1.0: Analytics</span>
    </v-footer>
  </v-app>
</template>

<script>
import {mapActions, mapState} from 'vuex'

export default {
  name: 'App',
  computed: {
    ...mapState({
      isLogged: 'isLogged'
    })
  },
  async created() {
    this.getDPUrl()
  },
  async mounted() {
    this.fetchAllCostCenters()
    this.fetchAllRegions()
  },
  methods: {
    ...mapActions({
      logout: 'logout',
      toggleDevMode: 'toggleDevMode',
      fetchAllCostCenters: 'fetchAllCostCenters',
      fetchAllRegions: 'fetchAllRegions',
      getDPUrl: 'fetchDPUrlActions'
    }),
  }
}
</script>

<style>

  @media (min-width: 1200px) {
    table {
      word-break: break-all;
      table-layout: fixed;
    }

    th {
      white-space: normal !important;
    }
  }

  .main-menu .main-menu-item {
    -ms-flex-align: center;
    align-items: center;
    display: -ms-inline-flexbox;
    display: inline-flex;
    -ms-flex: 0 1 auto;
    flex: 0 1 auto;
    font-size: 14px;
    font-weight: 500;
    height: inherit;
    line-height: normal;
    max-width: 264px;
    text-align: center;
    text-transform: uppercase;
    vertical-align: middle;
    cursor: pointer;
  }

  .main-menu .main-menu-item a.router-link-exact-active {
    border-bottom: solid 2px #b3d4fc;
    opacity: 1
  }

  .main-menu .main-menu-item a {
    -moz-user-select: none;
    -ms-user-select: none;
    -webkit-user-select: none;
    -ms-flex-align: center;
    align-items: center;
    color: inherit;
    display: -ms-flexbox;
    display: flex;
    -ms-flex: 1 1 auto;
    flex: 1 1 auto;
    height: 100%;
    -ms-flex-pack: center;
    justify-content: center;
    max-width: inherit;
    padding: 6px 12px;
    text-decoration: none;
    transition: .3s cubic-bezier(.25, .8, .5, 1);
    user-select: none;
    white-space: normal;
    opacity: .7;
    border-bottom: solid 2px transparent;
  }

  .content-wrapper {
    margin-top: 50px;
    margin-bottom: 36px;
  }

  .tight table thead td:not(:nth-child(1)),
  .tight table tbody td:not(:nth-child(1)),
  .tight table thead th:not(:nth-child(1)),
  .tight table tbody th:not(:nth-child(1)),
  .tight table thead td:first-child,
  .tight table tbody td:first-child,
  .tight table thead th:first-child,
  .tight table tbody th:first-child {
    padding: 0 12px !important;
  }

  .tight table tfoot tr td {
    padding: 0 12px !important;
  }

  .tight table {
    width: auto !important;
    word-break: normal;
  }

  table {
    word-break: break-word !important;
  }

  .unimInlineBlock {
    display: inline-block;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue